
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
// 引入自定义语言配置文件
import cs from './config/zh'
import en from './config/en'
Vue.use(VueI18n);
// 创建vue-i18n实例i18n
const i18n = new VueI18n({
    // 设置默认语言en
    locale: localStorage.getItem('locale') || 'en', // 语言标识
    // 添加多语言（每一个语言标示对应一个语言文件）
    messages: {
        'cs': Object.assign(cs, zhLocale),
        'en': Object.assign(en, enLocale),
    }
})
// console.log(i18n.locale ,i18n.messages,'i18n i18n i18n i18n i18n i18n ', localStorage.getItem('locale'))
// 暴露i18n
export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js